import {
  CorporateFare,
  Public,
  EmojiNature,
  Money,
  AccountBalance,
  DeviceThermostat,
  Factory,
  Gavel,
  WaterDrop,
  ListAlt
} from "@mui/icons-material";
import DM_SanPham from "./SanPham";
import DM_ThoiTietCucDoan from "./ThoiTietCucDoan";
import DM_BenhHai from "./BenhHai";
import DM_ThuocTruSau from "./ThuocTruSau";
import DM_PhanBon from "./PhanBon";
// End
export const DanhMucGroup = [
  { label: "Danh mục dùng chung", icon: <Public />, id: "cpbnbh" }
  // { label: 'Nguồn thải', icon: <Factory />, id: 'nguonthai' },
  // { label: 'Chất lượng môi trường', icon: <WaterDrop />, id: 'chatluongmt' },
  // { label: 'Đa dạng sinh học', icon: <EmojiNature />, id: 'dadangsh' },
  // { label: 'Danh mục khác', icon: <ListAlt />, id: 'danhmuckhac' },
  // { label: 'Quan trắc', icon: <DeviceThermostat />, id: 'quantrac' },
  // { label: 'Cơ quan/đơn vị', icon: <Public />, id: 'cqdv' },
];
export const DanhMucList = [
  {
    path: "sanpham",
    name: `Sản phẩm`,
    group: "cpbnbh",
    childRoute: [
      {
        path: "",
        main: () => <DM_SanPham group="cpbnbh" />
      }
    ]
  },
  {
    path: "thoitietcucdoan",
    name: `Thời tiết cực đoan`,
    group: "cpbnbh",
    childRoute: [
      {
        path: "",
        main: () => <DM_ThoiTietCucDoan group="cpbnbh" />
      }
    ]
  },
  {
    path: "benhhai",
    name: `Bệnh hại`,
    group: "cpbnbh",
    childRoute: [
      {
        path: "",
        main: () => <DM_BenhHai group="cpbnbh" />
      }
    ]
  },
  {
    path: "thuoctrusau",
    name: `Thuốc trừ sâu`,
    group: "cpbnbh",
    childRoute: [
      {
        path: "",
        main: () => <DM_ThuocTruSau group="cpbnbh" />
      }
    ]
  },
  {
    path: "phanbon",
    name: `Phân bón`,
    group: "cpbnbh",
    childRoute: [
      {
        path: "",
        main: () => <DM_PhanBon group="cpbnbh" />
      }
    ]
  }
];
